angular.module('picmonic-common').factory('TestimonialsResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/testimonials/:resource/:resource_id',
      {
        resource: '@resource',
        resource_id: '@resource_id',
      },
      {
        redeem_reward: {
          method: 'POST',
          url: '/api/v3/admin/testimonials/:resource_id/redeem-reward',
          isArray: true,
        },
      }
    );
  },
]);
